"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
function SidebarItem(props) {
  var active = props.active,
      item = props.item,
      _onClick = props.onClick,
      labelVisible = props.labelVisible,
      expanded = props.expanded;
  var name = item.name,
      route = item.route,
      label = item.label,
      Icon = item.icon;
  var isActive = active && active.startsWith(route);
  var hasChildren = Array.isArray(item.children) && item.children.length > 0;
  var className = (0, _classnames.default)('flex flex-row text-center flex-nowrap relative', 'py-3 pointer transition-padding cursor-pointer justify-start', isActive ? 'bg-default-orange' : 'bg-auxiliar-blue', expanded ? 'pr-6 pl-10' : 'px-0');
  var iconClassName = (0, _classnames.default)('inline-flex rounded-md justify-start items-center font-normal', isActive ? 'fill-black' : 'fill-white', expanded ? 'pr-4' : 'ml-3');
  var labelClassName = (0, _classnames.default)('opacity-0 transition-opacity font-normal duration-150', labelVisible && 'visible opacity-100', isActive ? 'text-black' : 'text-white');
  return /*#__PURE__*/_react.default.createElement("li", {
    tabIndex: "-1",
    key: route,
    className: className,
    onClick: function onClick() {
      return _onClick(name, hasChildren && item.children[0].name);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: iconClassName
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    width: "1.5rem",
    height: "1.5rem"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: labelClassName
  }, label), isActive && /*#__PURE__*/_react.default.createElement("span", {
    className: "arrow-left"
  }));
}

SidebarItem.propTypes = {
  onClick: _propTypes.default.func,
  labelVisible: _propTypes.default.bool,
  active: _propTypes.default.string,
  item: _propTypes.default.any,
  expanded: _propTypes.default.bool
};
SidebarItem.defaultProps = {
  onClick: _noop2.default
};
var _default = SidebarItem;
exports.default = _default;